import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ChevronRight } from "lucide-react";

/**
 * DS CategoryChip — 적용된 카테고리/필터 chip.
 * "대분류 > 중분류 > 소분류" 경로를 chevron으로 구분 표시 + 우측 삭제(x) 버튼.
 *
 * @param {object} props
 * @param {string[]} props.segments - 카테고리 경로 (예: ["음료", "커피", "라떼"])
 * @param {() => void} [props.onDelete]
 * @param {string} [props.className]
 */
const DSCategoryChip = ({ segments = [], onDelete, className = "" }) => {
  return (
    <div className={`ds-chip ${className}`}>
      <span className="ds-chip__path">
        {segments.map((seg, idx) => (
          <React.Fragment key={`${seg}-${idx}`}>
            {idx > 0 && (
              <ChevronRight size={14} className="ds-chip__chevron" />
            )}
            <span className="ds-chip__segment" title={seg}>
              {seg}
            </span>
          </React.Fragment>
        ))}
      </span>
      {onDelete && (
        <button
          type="button"
          className="ds-chip__delete"
          onClick={onDelete}
          aria-label="삭제"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
};

export default React.memo(DSCategoryChip);
